import * as React from 'react';

import SearchBar from 'bundles/search-common/components/searchbar/SearchBar';

const ConsumerSearchBarGridItem = () => {
  return <SearchBar />;
};

export default ConsumerSearchBarGridItem;
